import VueRouter, { RouteConfig } from 'vue-router'

const Index = () => import('../activity/seniorHighSchoolEntranceExam/Index.vue')

export const seniorHighSchoolEntranceExamActivityRoute: RouteConfig = {
  path: '/senior-high-school-entrance-exam-activity',
  name: 'senior-high-school-entrance-exam-activity',
  component: Index,
  meta: {
    title: '中考活动',
  },
}

export default [seniorHighSchoolEntranceExamActivityRoute]

export function navigateToSeniorHighSchoolEntranceExamActivity(router: VueRouter) {
  router.push({ name: seniorHighSchoolEntranceExamActivityRoute.name })
}
